































































// import AddEmailMutation from '@/graphql/mutations/addEmailRequest.gql';
// import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class EmailUs extends Vue {
  @Prop() public showClass!: string;
  @Prop() public showText!: string;
  @Prop() public showTitle!: string;
  @Prop() public summaryLabel!: string;
  @Prop() public textLabel!: string;
  @Prop() public summaryPlaceholder!: string;
  @Prop() public textPlaceholder!: string;
  @Prop() public typeOfContact!: string;
  @Prop() public buttonClass?: string;

  public isActive = false;
  public errorMessage: string = '';
  public email = '';
  public summary = '';
  public text = '';
  public buttonDisplayClass: string = '';
  public disabled = false;
  public emailSuccess = false;

  public mounted() {
    this.buttonDisplayClass = !this.buttonClass
      ? 'button is-primary is-medium'
      : this.buttonClass;
  }

  public close() {
    this.isActive = false;
  }

  public show() {
    this.isActive = true;
    this.disabled = false;
    this.emailSuccess = false;
  }

  /*
  public sendEmail() {
    const email = this.email;
    const summary = this.summary;
    const text = this.text;
    const type = this.typeOfContact;

    this.errorMessage = '';

    if (!email || !summary || !text) {
      this.errorMessage = 'Please fill out all fields';
    } else {
      this.disabled = true;
      request(AddEmailMutation as any, { email, summary, text, type })
        .then(({ data, errors }) => {
          if (errors && errors.length) {
            throw errors;
          }
          this.disabled = false;
          this.emailSuccess = true;
        })
        .catch(error => {
          this.disabled = false;
          this.errorMessage = 'Please try again later.';
        });
    }
  }
  */
}
